﻿import '../../legend.css';
import '../../main.css';
import '../../main-desktop.css';
import '../../icons.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import './fwe.css';

import '../../okta-auth';

import {
    generateDetailsPanel
} from "../../queries/new-queries";

import {
    authClient
} from '../../okta-auth';

// ESRI
import Map from '@arcgis/core/Map.js'
import MapView from '@arcgis/core/views/MapView.js'
import TimeSlider from "@arcgis/core/widgets/TimeSlider.js";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js"
import WMSLayer from "@arcgis/core/layers/WMSLayer";
import TimeExtent from "@arcgis/core/TimeExtent.js";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol.js";
import Point from "@arcgis/core/geometry/Point.js";
import Graphic from "@arcgis/core/Graphic.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Search from "@arcgis/core/widgets/Search.js";
import esriConfig from "@arcgis/core/config.js";
import Basemap from "@arcgis/core/Basemap.js";
// import WebTileLayer from "@arcgis/core/layers/WebTileLayer.js";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer.js";

// import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils.js"';
// import webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils.js'

import { 
    GEOSERVER_URL, 
    INCORRECT_GEOSERVER_URL,
    APP_BASE_URL,
    INCORRECT_GEOSERVER_SUBDOMAIN,
    BOM_BASE_URL
} from '../../env';

// Bootstrap
import bootstrapBundleMin from '../../../public/lib/js/bootstrap.bundle.min.js';

// Navbar
import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

import {
    mapLayers,
    extraMapLayers
} from '../../map-layers';

// Local helpers
import {
    addMapIncidents
} from './helpers/map-incidents';

import {
    getJurisdictionsObj,
    getFireWeatherAreaObj,
    getFireManagementAreaObj,
    // The following 3 are for the bomObservations button
    getSurfaceWindObj,
    getRelativeHumidityObj,
    getAirTempObj,
    getRfsAreaCommandLayerObj
} from './helpers/get-settings-layer-obj';

import { isImageFormat } from '../../utils.js';


// ! GLOBAL VARIABLES

let esriMap;
let esriMapView;
let timeSlider;
let customBaseMaps = {};

// Used for ensuring the opacity values remain the same when switching layers
let opacityVal;
let speedVal;
let currentLayerObj;
let prevPoint;
let showLayersDebounce = false;
let buttonDebounceTimeMs = 250;

// Settings layers that are on
let incidentsOn = true;
let jurisdictionsOn = true;
let fireWeatherAreaOn = true;
let fireManagementAreaOn = false;
let bomObservationsOn = false;
let rfsAreaCommandOn = false;

let jurisdictionsLayer;
let fireWeatherAreaLayer;
let fireManagementAreaLayer;
let incidentsLayer;
let rfsAreaCommandLayer;

// The following 3 are for the bom observations
let surfaceWindLayer;
let relHumidLayer;
let airTempLayer;

const chartContainerId = 'google-chart-container-id';

const dateStringOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hourCycle: 'h23',
    timeZoneName: "short"
};

// ! INIT FUNCTIONS

/**
 * 
 */
function setupAccordionCollapse(layers) {
    $.map(layers, function(value, key) {
        const processedKey = key.toLowerCase().replace(/\s+/g, '-');
        $(`#${processedKey}-layer-heading`).on('click', function() {
            const navbarCollapse = $(`#${processedKey}-collapse`);
            var bsCollapse = bootstrapBundleMin.Collapse.getInstance(navbarCollapse);
            const isExpanded = navbarCollapse.hasClass('show');
            if(isExpanded) {
                // Add the 'collapsed' class to the header
                $(`#${processedKey}-layer-heading`).children('button').addClass('collapsed');
            } else {
                $(`#${processedKey}-layer-heading`).children('button').removeClass('collapsed');
            }
            if(bsCollapse) bsCollapse.toggle();
            else {
                bsCollapse = new bootstrapBundleMin.Collapse(navbarCollapse, {
                    toggle: true
                });
            }
        });
    });
}

/**
 * Generates the HTML for the various map layers and appends them to the DOM
 * NOTE : The default value is hard coded with the `isDefault` and `isDefaultAccordian`
 * parameters.
 */
function generateMapLayerBtns(defaultId) {
    
    // Thing that contains the map layers
    $('#fwe-map-layers-tab-id');

    const accordion = $(`<div class="accordion" id="fwe-layers-accordion"></div>`)

    $.map(mapLayers, function(value, key) {
        // Process the key to make it lowercase replace all spaces with hyphens
        const processedKey = key.toLowerCase().replace(/\s+/g, '-');

        var isDefaultAccordian = 'inactive';

        const accordionBody = $(`<div class="accordion-body"></div>`)

        // Generate each of the buttons from the keys
        for(let i = 0; i < value.length; i++) {
            const processedValueItem = value[i].layerLabel.toLowerCase().replace(/\s+/g, '-')
                    .replace('%', 'perc')
                    .replace('(', '')
                    .replace(')', '');
            var isDefault = 'inactive';
            if(defaultId === `${processedKey}-${processedValueItem}-layer-btn`) {
                isDefault = 'active';
                isDefaultAccordian = 'active';
            }

            const mayLayerBtn = $(`<button class="btn fwe-layer-btn-${isDefault}" ` +
                        `onclick="handleMapLayerBtnClick('${processedKey}', '${processedValueItem}', '${value[i].layerName}')" ` +
                        `id="${processedKey}-${processedValueItem}-layer-btn">` +
                    `${value[i].layerLabel}` +
                `</button>`);
            accordionBody.append(mayLayerBtn);
        }

        // Create the collapse wrapper and append the accordion body
        const accordionCollapse = $(`<div id="${processedKey}-collapse"` +
                `class="accordion-collapse collapse"` +
                `aria-labelledby="${processedKey}-layer-heading"` +
                `data-bs-parent="#fwe-layers-accordion">` +
            `</div>`);

        accordionCollapse.append(accordionBody);

        // This will be the base part to assemble the other parts from
        const accordionItem = $(`<div class="accordion-item"></div>`);

        const accordionHeader = $( `<h2 class="accordion-header" id="${processedKey}-layer-heading">` +
                `<button class="accordion-button collapsed"` +
                        `type="button"` +
                        // `data-bs-toggle="collapse"` +
                        `data-bs-target="#${processedKey}-collapse"` +
                        `aria-expanded="true"` +
                        `aria-controls="${processedKey}-collapse">` +
                    `${key} <i class="bi bi-circle-fill layer-indicator-icon-${isDefaultAccordian}"` +
                            `id="${processedKey}-indicator-icon"></i>` +
                `</button>` +
            `</h2>`);

        // Assemble the accordion item
        accordionItem.append(accordionHeader);
        accordionItem.append(accordionCollapse);

        // Append this accordion item to the accordion
        accordion.append(accordionItem);
    });
    
    // Append the accordion to the attachment point in the DOM
    $('#fwe-map-layers-tab-id').append(accordion).promise().done(function() {
        // Attach the various listeners to the accordion buttons
        setupAccordionCollapse(mapLayers);
    });
}

function attachPbftModalBtnListeners() {
    $('#modal-cancel-btn-id').on('click', function() {
        window.location.href = "https://www.rfs.nsw.gov.au/";
    });

    $('#modal-accept-btn-id').on('click', function() {
        $('#pbftDialog').modal('hide');
    })
}

/**
 * Attaches listeners to the four buttons at the top of the 
 * right-hand side navbar.
 */
function attachNavbarListeners() {
    const navBtns = [
        {
            btnId: '#search-tab-btn-id',
            tabId: '#fwe-search-tab-id'
        },
        {
            btnId: '#layers-tab-btn-id',
            tabId: '#fwe-map-layers-tab-id'
        },
        {
            btnId: '#details-tab-btn-id',
            tabId: '#fwe-details-tab-id'
        },
        {
            btnId: '#settings-tab-btn-id',
            tabId: '#fwe-settings-tab-id'
        }
    ];

    function __hideSubNavBarTabs() {
        $('[id$="-tab-id"]').each(function() {
            $(this).hide();
        });
    }
    
    function __unhighlightSubNavBarBtns() {
        $('[id$="tab-btn-id"').each(function() {
            $(this).removeClass('fwe-nav-btn-active');
            $(this).addClass('fwe-nav-btn-inactive');
        })
    }

    for(let i = 0; i < navBtns.length; i++) {
        $(navBtns[i].btnId).on("click", function() {
            // Hide every tab
            __hideSubNavBarTabs();
            // Remove the 'active' class from every button
            __unhighlightSubNavBarBtns();
            // Remove the 'inactive' class from this specific button
            $(navBtns[i].btnId).removeClass('fwe-nav-btn-inactive');
            // Add the 'active' class to this specific button
            $(navBtns[i].btnId).addClass('fwe-nav-btn-active');
            // Show the corresponding tab
            $(navBtns[i].tabId).show();
        });
    }
}

/**
 * Sets the playrate (which should be between 1 sec and 10 sec)
 * @param {*} speed A number from 1 to 10
 */
function computeSliderPlayRate(speed) {
    return (10 / speed) * 1000;
}

/**
 * Attaches listeners to the opacity and speed sliders in
 * the settings menu. Used to control the current layers 
 * opacity, and the playback speed for the timeslider.
 */
function setupSettingsSliderListener() {
    const opacitySlider = $('#fwe-map-opacity-slider-id');
    const speedSlider = $('#fwe-map-speed-slider-id');

    function idInMapLayers(id) {
        for(var key in mapLayers) {
            const currMapLayerGroup = mapLayers[key];
            if(currMapLayerGroup.find(e => e.geoserverId === id)) {
                return true;
            }
        }
        return false;
    }

    opacitySlider.on("input", function() {
        opacityVal = $(this).val();
        $('#opacity-number-id').html(opacityVal * 10);
        esriMap.allLayers.forEach(function(layer) {
            // Check if the layer's id is in the list of layers we care about
            if(idInMapLayers(layer.id)) {
                layer.opacity = opacityVal / 10;
            }
        });
    });

    // Set the default value for the opacity slider
    opacitySlider.val(7);

    speedSlider.on("input", function() {
        speedVal = $(this).val();
        $('#speed-number-id').html(speedVal);
        timeSlider.playRate = computeSliderPlayRate(speedVal);

    });

    // Set the default value for the time slider
    speedSlider.val(2);
}

function checkForecastMenuIsOpen() {
    const forecastMenu = $('#rightSidePanelId');
    const isOpen = forecastMenu.attr('isOpen');
    return isOpen === 'true';
}

function toggleSidePanelOpen() {
    // For some reason this triggers twice, so 
    if(showLayersDebounce) {
        return;
    };

    showLayersDebounce = true;
    setTimeout(() => {
        showLayersDebounce = false;
    }, buttonDebounceTimeMs);

    const forecastMenu = $('#rightSidePanelId');
    const isOpen = forecastMenu.attr('isOpen');

    if(isOpen === 'true') {
        // Closing
        forecastMenu.slideUp();
        forecastMenu.attr('isOpen', 'false');
        $(this).removeClass('legend-button-on');
        $(this).addClass('legend-button');
    } else {
        // Opening
        forecastMenu.slideDown();
        forecastMenu.attr('isOpen', 'true');
        $(this).removeClass('legend-button');
        $(this).addClass('legend-button-on');
    }

    $("#btnShowLayers").toggleClass('legend-button-on legend-button');
}

/**
 * Attaches listeners to the footer buttons; those being (left-to-right):
 * - Show / hide the map legend
 * - Navigate to the info page
 * - Show / hide the right-hand panel
 */
function setupFooterButtonListeners() {
    // Setup the 
    $("#btnShowLayers").on("click", function(event) {
        toggleSidePanelOpen();

        event.preventDefault();
        event.stopPropagation();
    });

    $("#btnShowLegend").on("click", function(event) {
        $("#legend-container-id").slideToggle();

        $(this).toggleClass('legend-button-on legend-button');
    });

    $('#btnShowMetaData').on('click', function(event) {
        let baseUrl = 'admin.html'

        let params = {
            layer: currentLayerObj.layerName
        }

        let url = baseUrl + '?' + $.param(params);

        window.open(url, '_blank');
    })
}

/**
 * Attaches a listener to the dropdown menu button that controls
 * the selected basemap.
 */
function setupBasemapDropdownBtn() {
    $('#basemap-btn-id').on("click", function() {
        const dropdownUl = $("#basemap-ul-dd-id");
        
        if($(this).hasClass("show")) {
            $(this).removeClass("show");
            dropdownUl.removeClass("show");
        } else {
            $(this).addClass("show");
            dropdownUl.addClass("show");
        }
    })

    $('[id$="-bm-id"]').each(function() {
        $(this).on("click", function() {
            if(['lpiimagery', 'lpibasemap'].includes($(this).attr('value'))) {
                console.log("Setting lpi map");
                esriMap.basemap = customBaseMaps[$(this).attr('value')];
            } else {
                esriMap.basemap = $(this).attr('value');
            }
            $('#selected-basemap-id').html($(this).html());
        })
    })
}

/**
 * Refreshes the incidents that are displayed on the map.
 * @param {*} timeout The amount of time (in ms) between each refresh
 */
function incidentsRefreshLoop(timeout) {
    // Clear the layer for all the graphics
    incidentsLayer.graphics.removeAll();

    addMapIncidents(incidentsLayer);
    
    setTimeout(() => {
        incidentsRefreshLoop(timeout);
    }, timeout)
}

/**
 * Button for toggling specific settings in the settings tab on or off.
 * @param {*} type A string denoting which button is being pushed
 * @param {*} toggleOn Whether the functionality is being toggled on or off.
 */
function toggleSettingsBtn(type, toggleOn) {

    switch(type) {
        case 'incidents':
            toggleOn ? esriMap.add(incidentsLayer) : esriMap.remove(incidentsLayer);
            incidentsOn = toggleOn;
            break;
        case 'jurisdiction':
            toggleOn ? esriMap.add(jurisdictionsLayer) : esriMap.remove(jurisdictionsLayer);
            jurisdictionsOn = toggleOn;
            break;
        case 'fire-weather-area':
            toggleOn ? esriMap.add(fireWeatherAreaLayer) : esriMap.remove(fireWeatherAreaLayer);
            fireWeatherAreaOn = toggleOn;
            break;
        case 'fire-management-area':
            toggleOn ? esriMap.add(fireManagementAreaLayer) : esriMap.remove(fireManagementAreaLayer);
            fireManagementAreaOn = toggleOn;
            break;
        case 'rfs-area-command':
            toggleOn ? esriMap.add(rfsAreaCommandLayer) : esriMap.remove(rfsAreaCommandLayer);
            rfsAreaCommandOn = toggleOn;
            break;
        case 'bom-observations':
            if(toggleOn) {
                esriMap.add(surfaceWindLayer);
                esriMap.add(relHumidLayer);
                esriMap.add(airTempLayer);
            } else {
                esriMap.remove(surfaceWindLayer);
                esriMap.remove(relHumidLayer);
                esriMap.remove(airTempLayer);
            }
            bomObservationsOn = toggleOn;
            break;
        default:
            console.error(`Unhandled settings btn case ${type}`);
    }
}

/**
 * Sets up listeners that handle button clicks for each of the settings
 * buttons that add / remove basemap layers
 * (any additional functionality will need to be implemented separately)
 */
function setupSettingsBtnListeners() {
    $('[id$="-settings-btn-id"]').each(function() {
        $(this).on("click", function() {
            if($(this).hasClass('settings-button-on')) {
                $(this).removeClass('settings-button-on').addClass('settings-button');
                toggleSettingsBtn($(this).attr('value'), false);
            } else {
                $(this).removeClass('settings-button').addClass('settings-button-on');
                toggleSettingsBtn($(this).attr('value'), true);
            }
        })
    });
}

/**
 * Initialises the various layers in the settings tab.
 */
function initSettingsLayers() {
    jurisdictionsLayer = createWmsLayer(getJurisdictionsObj());
    fireWeatherAreaLayer = createWmsLayer(getFireWeatherAreaObj());
    fireManagementAreaLayer = createWmsLayer(getFireManagementAreaObj());
    // The following 3 layers are for the bomObservations button
    surfaceWindLayer = createWmsLayer(getSurfaceWindObj());
    relHumidLayer = createWmsLayer(getRelativeHumidityObj());
    airTempLayer = createWmsLayer(getAirTempObj())

    // Add RFS Area Layer
    rfsAreaCommandLayer = createMapServiceLayer(getRfsAreaCommandLayerObj())


}

// ! HANDLER FUNCTIONS

function handleMapClick(event) {
    const opts = {
        include: incidentsLayer
    }

    // The hitTest will check if we're clicking on a graphic or not
    esriMapView.hitTest(event, opts).then(function(response) {
        if(response.results.length) {
            // ! Debug code for testing whether the graphic icons interfere
            // ! with the regular map click handler (which brings up the details panel)
            var graphic = response.results[0].graphic;
            if(graphic) {
                // console.log("Yes you clicked on a graphic");
            } else {
                // console.log("No graphic found")
            }
        } else {
            // Graphic is not clicked, therefore process the pin drop normally
            const spatialRef = esriMapView.spatialReference;
            const latitude = event.mapPoint.latitude;
            const longitude = event.mapPoint.longitude;

            // Check if the side panel is open or not
            if(!checkForecastMenuIsOpen()) {
                // Open the side panel
                toggleSidePanelOpen();
            }

            if(prevPoint)
                esriMapView.graphics.remove(prevPoint)

            // Define the point geometry
            const geometryPoint = new Point({
                longitude: longitude,
                latitude: latitude
            })

            // Create the icon for the dropdown
            const newSymbol = new PictureMarkerSymbol({
                url: 'img/pin-red.png',
                width: "30px",
                height: "30px",
            });

            prevPoint = new Graphic({
                symbol: newSymbol,
                geometry: geometryPoint
            })

            esriMapView.graphics.add(prevPoint)

            // Store the current click data locally
            localStorage.setItem('fwfv_clicked_lat', latitude);
            localStorage.setItem('fwfv_clicked_lon', longitude);
            localStorage.setItem('fwfv_clicked_layer', currentLayerObj['geoserverId'])

            $(`#details-tab-btn-id`).trigger('click');

            // Load the Visualization API and the corechart package.
            google.charts.load('current', {'packages':['corechart']});
            google.charts.setOnLoadCallback(() => generateDetailsPanel(
                    event, 
                    spatialRef, 
                    currentLayerObj, 
                    chartContainerId));
        }
    });
}

function setTimesliderVisibility(showTimeslider) {
    const timesliderContainer = $('#timeslider-container-id');
    // const footerButtonsContainer = $('#footer-buttons-container-id');
    const noDataContainer = $('#no-data-container-id');

    if(showTimeslider) {
        // Show the timeslider
        timesliderContainer.show();
        // footerButtonsContainer.show();
        noDataContainer.addClass("hide-container-none");
    } else {
        timesliderContainer.hide();
        // footerButtonsContainer.hide();
        noDataContainer.removeClass("hide-container-none");
    }
}

/**
 * Returns the timestep that is closest to the given timeslider date
 * @param {*} timesliderDate 
 * @param {*} datesArray 
 * @returns 
 */
function getClosestTimeStep(timesliderDate, datesArray) {
    const differenceArray = [];
    for(let i = 0; i < datesArray.length; i++) {
        differenceArray.push(Math.abs(timesliderDate - datesArray[i]));
    }

    const minDiff = Math.min(...differenceArray);
    const minDiffIndex = differenceArray.indexOf(minDiff);
    const closestTimestep = datesArray[minDiffIndex];

    return closestTimestep;
}

/**
 * 
 */
function setMapTimeStep(timesliderDate) {
    const irrelevantLayers = ['streets-vector-base-layer'];

    // Find the map that's selected
    for (const layer of esriMap.allLayers){

        // do something with each view graphic
        if(irrelevantLayers.includes(layer.id)) continue;
        
        // Get the timesteps for this layer
        let rasterLayer = null;
        for(var key in mapLayers) {
            const currMapLayerGroup = mapLayers[key];
            rasterLayer = currMapLayerGroup.find(e => e.geoserverId === layer.id);
            if(rasterLayer) break;

        }

        if(!rasterLayer) {
            // Try the extra map layers
            for(var key in extraMapLayers) {
                const currExtraMapLayer = extraMapLayers[key];
                rasterLayer = layer.id == currExtraMapLayer.geoserverId ? currExtraMapLayer : null;
                if(rasterLayer) break;
            }
        }
        
        
        if(!rasterLayer) {
            console.error("Couldn't find a matching layer");
            return;
        };

        // Set the closest timestep
        const closestTimestep = getClosestTimeStep(
                timesliderDate, rasterLayer.timeSteps);
        
        // Set the header for the map
        setTimesliderHeaderValue(rasterLayer, closestTimestep);
        esriMapView.timeExtent = new TimeExtent({
            start: new Date(closestTimestep),
            end: new Date(closestTimestep)
        });
        break;
    }
}

/**
 * Sets a new raster to the map 
 */
function switchLayer(layerName) {
    if(layerName === 'RFS_PBFT_SFC') {
        // Display the popup to accept or cancel
        $('#pbftDialog').modal('show');
    }

    let layerObj = null;
    let extraLayerObj = null;
    for(var key in mapLayers) {
        const currMapLayerGroup = mapLayers[key];
        layerObj = currMapLayerGroup.find(e => e.layerName === layerName);
        if(layerObj) break;
    }

    if(!layerObj) {
        console.error(`Couldn't find match for layerName : ${layerName}`);
        return;
    };

    // Get the current timeExtent from the timeslider
    const currentTimeSliderDate = timeSlider.timeExtent.end;
    const closestDate = getClosestTimeStep(currentTimeSliderDate, layerObj.timeSteps);
    console.log(`Closest date : ${closestDate}`);
    let stopInterval = 1;
    let isSingleTimestep = false;
    
    const newLayerTimeInterval = layerObj.timeStepInterval.toLowerCase();
    switch(newLayerTimeInterval) {
        case 'hourly':
            stopInterval = 1;
            break;
        case '3-hourly':
            stopInterval = 3;
            break;
        case 'daily':
            stopInterval = 24
            break;
        case 'singlestep':
            stopInterval = null;
            isSingleTimestep = true;
            break;
        case '':
            stopInterval = null;
            break;
        default:
            console.error(`Unknown timestep interval : ${newLayerTimeInterval}`)
    }

    // Clear the current map layers
    esriMap.removeAll();


    esriMap.add(createWmsLayer(layerObj));

    // Handle the case for wind layers
    switch(layerObj.layerLabel) {
        case '(Average) Wind Magnitude on Hour':
            extraLayerObj = extraMapLayers['Wind Direction'];
            esriMap.add(createWmsLayer(extraLayerObj));
            break;
        case '(Average) Wind Max In Hour':
            extraLayerObj = extraMapLayers['Wind Direction'];
            esriMap.add(createWmsLayer(extraLayerObj));
            break;
        case '1500m Wind':
            extraLayerObj = extraMapLayers['1500m Wind'];
            esriMap.add(createWmsLayer(extraLayerObj));
            break;
    }


    if(incidentsOn) {
        esriMap.add(incidentsLayer);
    }

    // The jurisdiction should default to on
    if(jurisdictionsOn) {
        esriMap.add(jurisdictionsLayer);
    }

    // The fireweather area should default to on
    if(fireWeatherAreaOn) {
        esriMap.add(fireWeatherAreaLayer);
    }

    // The fire management area should default to OFF
    if(fireManagementAreaOn) {
        esriMap.add(fireManagementAreaLayer);
    }

    if(rfsAreaCommandOn) {
        esriMap.add(rfsAreaCommandLayer);
    }

    if(bomObservationsOn) {
        esriMap.add(surfaceWindLayer);
        esriMap.add(relHumidLayer);
        esriMap.add(airTempLayer);
    }

    console.log(stopInterval);

    if(stopInterval != null) {
        setTimesliderVisibility(true);
        timeSlider.stops = {
            interval: {
                value: stopInterval,
                unit: "hours"
            }
        }

        timeSlider.timeExtent.end = roundToNearestDay(closestDate);
        setMapTimeStep(roundToNearestDay(closestDate));
    } else {
        if (isSingleTimestep) {
            timeSlider.timeExtent.end = roundToNearestDay(closestDate);
            setMapTimeStep(roundToNearestDay(closestDate));
        }
        setTimesliderVisibility(false);
    }

    const legendContainer = $('#legend-container-id');
    const showLegendBtn = $('#btnShowLegend');
    if(layerObj.hasLegend) {
        switch(layerObj.layerLabel) {
            case '(Average) Wind Magnitude on Hour':
            case '1500m Wind':
                loadLegendHTML(layerObj);
                break;
            case 'Weather Stations':
                loadLegendWeatherStationIcons(layerObj);
                break;
            default:
                loadLegendHTML(layerObj);
        }
        showLegendBtn.prop("disabled", false);
        legendContainer.show();
    } else {
        showLegendBtn.prop("disabled", true);
        legendContainer.hide();
    }
    currentLayerObj = layerObj;   
}

/**
 * Handles the map layer buttons getting clicked
 * 
 * 
 * @param {*} btnId 
 */
export function handleMapLayerBtnClick(btnId, layerBtnId, layerName) {

    switchLayer(layerName);

    localStorage.setItem('fwfv_maplayer', layerName);

    // if (layerResolved.id == "RFS_PBFT_SFC") {
    //     $('#pbftDisclaimer').modal('show');
    // }
    
    // Set all the layer map buttons blank
    $('[id$="-layer-btn"]').each(function() {
        $(this).removeClass('fwe-layer-btn-active');
        $(this).addClass('fwe-layer-btn-inactive');
    });

    // Set the button that was clicked to active
    const layerBtn = $(`#${btnId}-${layerBtnId}-layer-btn`);
    layerBtn.removeClass('fwe-layer-btn-inactive');
    layerBtn.addClass('fwe-layer-btn-active');

    // Set the 'active' dot on the corresponding header group
    $('[id$="-indicator-icon"]').each(function() {
        $(this).removeClass('layer-indicator-icon-active');
        $(this).addClass('layer-indicator-icon-inactive');
    });

    const activeHeader = $(`#${btnId}-indicator-icon`);
    activeHeader.removeClass('layer-indicator-icon-inactive');
    activeHeader.addClass('layer-indicator-icon-active');
}

function addInterceptors(){
    const { accessToken } = authClient.tokenManager.getTokensSync();
    esriConfig.request.interceptors.push({
        urls: [`${APP_BASE_URL}/geoserver`,`${APP_BASE_URL}/arcgis`,`${APP_BASE_URL}/bom`, INCORRECT_GEOSERVER_URL, BOM_BASE_URL],
        headers: {
            Authorization: 'Bearer ' + accessToken.accessToken
        },
        // change request before it is sent
        before: function(params) {
            // Replaces the incorrect geoserver url with the correct one
            if (params.url.includes(INCORRECT_GEOSERVER_URL)) {
                params.url = params.url.replace(INCORRECT_GEOSERVER_URL, GEOSERVER_URL); 
            }
            if (params.url.includes(`${BOM_BASE_URL}/cgi-bin/mapserver/users/bomw0784/wxs`)){
                params.url = params.url.replace(`${BOM_BASE_URL}/cgi-bin/mapserver/users/bomw0784/wxs`, `${APP_BASE_URL}/bom/wms`);
            }
        }
    });
}

// ! MAP INIT FUNCTIONS

/**
 * Creates a new `WMSLayer` object and returns it
 * @param layerName : The name of the raster layer to use 
 */
function createWmsLayer(layerObj, startDate = undefined) {
    let sublayer;

    if ('layerWorkspace' in layerObj) {
        sublayer = layerObj.layerWorkspace ? `${layerObj.layerWorkspace}:${layerObj.geoserverId}`: layerObj.geoserverId;
    }
    else {
        sublayer = `fireweather:${layerObj.geoserverId}`;
    }

    const timeExtent = startDate ? new TimeExtent({
        start: new Date(startDate),
        end: new Date(startDate)
    }) : null;

    let serviceUrl =layerObj?.serviceUrl ?? GEOSERVER_URL;
    serviceUrl = serviceUrl.replace("{APP_BASE_URL}", APP_BASE_URL);

    const newLayer = new WMSLayer({
        id: `${layerObj.geoserverId}`,
        url: serviceUrl,
        opacity: 0.7,
        sublayers: [{
            name: sublayer
        }],
        timeExtent: timeExtent,
    });

    return newLayer;
}

/**
 * Creates a new `MapImageLayer` object and returns it
 * @param layerObj : Layer object 
 */
function createMapServiceLayer(layerObj) {
    let serviceUrl = layerObj?.serviceUrl ?? '';
    if (!serviceUrl)
        return
    serviceUrl = serviceUrl.replace("{APP_BASE_URL}", APP_BASE_URL);
    const newLayer = new MapImageLayer({
        url: serviceUrl,
        opacity: 0.7,
        sublayers: [
             {
                id: layerObj.sublayer?.id ?? 0,
                ...(layerObj.definitionExpression && { definitionExpression: layerObj.definitionExpression })
             },
        ],
    }); 

    return newLayer;
}


function generateLegendItem(colour, label, unit) {
    const legendContainer = $(`<div class="legend-item-container"></div>`);
    const legendSquare = $(`<div style="background-color: ${colour}" class="legend-item-style"></div>`);
    const legendLabel = $(`<div class="legend-item-label">${label} ${unit}</div>`);

    legendContainer.append(legendSquare);
    legendContainer.append(legendLabel);

    return legendContainer;
}

function loadLegendWeatherStationIcons(rasterLayer) {
    const legendContainer = $(`#legend-contents-id`);

    const params = new URLSearchParams({
        request: 'GetLegendGraphic',
        service: 'WMS',
        version: '1.1.1',
        layer: `fireweather:${rasterLayer.geoserverId}`,
        format: 'application/json'
    });

    $.ajax({
        url: GEOSERVER_URL,
        method: "GET",
        data: params.toString(),
        success: function(response) {
            // Clear the legend
            legendContainer.html('');
            // Get all the legend external graphics
            const entries = response.Legend[0].rules;
            entries.forEach((entry, idx) => {
                let gfxUrl = entry.symbolizers[0].Point.graphics[0]['external-graphic-url'];
                gfxUrl = gfxUrl.replace(INCORRECT_GEOSERVER_SUBDOMAIN, "shared-fireweather")
                console.log(gfxUrl);

                // Create the legend item graphic
                const legendItemCont = $(`<div class="weather-station-legend-container" id="weather-obs-item-cont-${idx}"></div>`);
                legendItemCont.append(
                    `<img class="weather-station-legend-icon" src=${gfxUrl}>`
                );
                
                // Add in the weather stations name
                legendItemCont.append(
                    `<div class="weather-station-legend-label">${entry.name}</div>`
                )
                
                // Append the legend item
                legendContainer.append(legendItemCont);
            })
        },
        error: function(xhr, status, error) {
            // Clear the legend
            legendContainer.html('<i>Failed to fetch the legend </i>');
            console.error("Error:", error);
            // Handle error here
        }
    })
}

function loadLegendHTML(rasterLayer) {
    const legendContainer = $(`#legend-contents-id`);

    const legendFormat = rasterLayer.legendFormat ? rasterLayer.legendFormat: 'application/json';

    let sublayer;

    if ('layerWorkspace' in rasterLayer) {
        sublayer = rasterLayer.layerWorkspace ? `${rasterLayer.layerWorkspace}:${rasterLayer.geoserverId}`: rasterLayer.geoserverId;
    }
    else {
        sublayer = `fireweather:${rasterLayer.geoserverId}`;
    }

    let serviceUrl =rasterLayer?.serviceUrl ?? GEOSERVER_URL;
    serviceUrl = serviceUrl.replace("{APP_BASE_URL}", APP_BASE_URL);
    const { accessToken } = authClient.tokenManager.getTokensSync();

    const params = new URLSearchParams({
        request: 'GetLegendGraphic',
        service: 'WMS',
        version: '1.1.1',
        layer: sublayer,
        format: legendFormat
    });

    $.ajax({
        url: serviceUrl,
        method: "GET",
        headers:{
            Authorization: `Bearer ${accessToken.accessToken}`
        },
        xhrFields: {
           responseType: isImageFormat(legendFormat) ? "blob": "text"
        },
        data: params.toString(),
        success: function(response) {
            // Clear the legend
            legendContainer.html('');
            if (legendFormat == "application/json"){
                const colourMapEntries = response['Legend'][0]['rules'][0]['symbolizers'][0]['Raster']['colormap']['entries'];
                for(let i = 0; i < colourMapEntries.length; i++) {
                    const entry = colourMapEntries[i];
                    if(entry['label'] === 'nodata') continue;
                    const legendItem = generateLegendItem(entry['color'], entry['label'], rasterLayer['legendUnits']);
                    legendContainer.append(legendItem);
                }
            }
            else {
                const imgURL = URL.createObjectURL(response);
                const img = document.createElement("img");
                img.src = imgURL;
                img.alt = "Legend";
                legendContainer.append(img);
            }
        },
        error: function(xhr, status, error) {
            console.error("Error:", error);
            legendContainer.html('<i>Failed to fetch the legend </i>');
            // Handle error here
        }
    })
}

/**
 * Loads the ESRI basemap into the map container
 */
function initialiseEsriBasemap(initialLayer) {
    const mapCenter = [151.209, -33.865]; // Longitude, latitude
    const defaultZoom = 5;

    const layerObj = createWmsLayer(initialLayer);

    esriMap = new Map({
        basemap: 'streets',
        layers: [layerObj]
    });

    esriMapView = new MapView({
        map: esriMap,
        zoom: defaultZoom,
        container: "map1",
        center: mapCenter,
        navigation: {
            momentumEnabled: false,
        }
    });

    esriMapView.constraints = {
        rotationEnabled: false
    };

    // Load the legend
    loadLegendHTML(initialLayer);

    // Attach the listener for map clicks
    esriMapView.on("click", handleMapClick);

    // The jurisdiction should default to on
    if(jurisdictionsOn) {
        esriMap.add(jurisdictionsLayer);
    }

    // The fireweather area should default to on
    if(fireWeatherAreaOn) {
        esriMap.add(fireWeatherAreaLayer);
    }

    // The fire management area should default to OFF
    if(fireManagementAreaOn) {
        esriMap.add(fireManagementAreaLayer);
    }

    // The rfs area command layer default is OFF
    if(rfsAreaCommandOn && rfsAreaCommandLayer) {
        esriMap.add(rfsAreaCommandLayer);
    }

    // Create the custom basemaps
    /**
     * NOTE : This is really unintuitive. There are many different types of layers available,
     * VectorTileLayer, WebTileLayer, but the one we need is TileLayer. Confusing I know.
     * Because the url has "arcgis/rest/.../MapServer", we know its an ArcGIS server (and thus we need to use
     * the layer that specifically works for that).
     * That used to be called `ArcGISTiledLayer`, but now it's just called `TiledLayer`.
     * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-TileLayer.html
     */
    customBaseMaps = {
        'lpibasemap': new Basemap({
            baseLayers: [
                new TileLayer({
                    url: "https://maps.six.nsw.gov.au/arcgis/rest/services/public/NSW_Base_Map/MapServer"
                })
            ],
            title: "LPI Basemap",
            id: 'lpibasemap',
            thumbnailUrl: "https://www.example.com/images/thumbnail_2014-11-25_61051.png"
        }),
        'lpiimagery': new Basemap({
            baseLayers: [
                new TileLayer({
                    url: "https://maps.six.nsw.gov.au/arcgis/rest/services/public/NSW_Imagery/MapServer"
                })
            ],
            title: "LPI Imagery",
            id: 'lpiimagery',
            thumbnailUrl: "https://www.example.com/images/thumbnail_2014-11-25_61051.png"
        })
    }
}

// ! TIMESLIDER INIT

/**
 * Sets the header value of the map cells
 * e.g. Temperature : Tuesday, April 30, 2024 at 06:00 GMT+10
 */
function setTimesliderHeaderValue(mapLayer, timestep) {
    const dateStr = timestep.toLocaleDateString('en-US', dateStringOptions);

    $(`#timeslider-header-id`).html(
        `<span class="timeslider-header-layer-name">${mapLayer.layerLabel} :</span>` + 
        `<span class="timeslider-header-time-info">${dateStr}</span>`
    )
}

function roundToNearestDay(date) {
    // Clone the original date to avoid modifying it
    var roundedDate = new Date(date);

    // Set hours, minutes, seconds, and milliseconds to 0
    roundedDate.setHours(0, 0, 0, 0);

    // Check if the time is closer to the next day or the previous day
    var nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    var timeDiffToNextDay = Math.abs(nextDay.getTime() - date.getTime());
    var timeDiffToPreviousDay = Math.abs(roundedDate.getTime() - date.getTime());

    // Round the date to the nearest day
    if (timeDiffToNextDay < timeDiffToPreviousDay) {
        roundedDate.setDate(roundedDate.getDate() + 1);
    }

    return roundedDate;
}

/**
 * Rounds a given date to the nearest hour
 * @param {*} date 
 * @returns 
 */
function roundToNearestHour(date) {
    const roundedDate = new Date(date); // Create a copy of the original date
    roundedDate.setMinutes(0); // Set minutes to 0 to round to the nearest hour
    roundedDate.setSeconds(0); // Set seconds to 0 for consistency
    roundedDate.setMilliseconds(0); // Set milliseconds to 0 for consistency

    // If the minutes are between 30 and 59, round to the next hour
    if (date.getMinutes() >= 30) {
        roundedDate.setHours(roundedDate.getHours() + 1);
    }

    return roundedDate;
}

/**
 * Extracts the timestamps for each of the layers returned from a 
 * GetCapabilities request.
 * 
 * THIS WILL LOAD ALL THE TIMESTEPS FOR ALL THE LAYERS
 * 
 * The document should have the following structure:
 * WMS_Capabilities > Capabilities > Layer
 * 
 * Timesteps should be under the layer
 * 
 * ! The console.log statements are left as comments to assist in debugging the 
 * ! `extractTimesteps` function in the future.
 * @param {*} xmlDoc 
 */
function extractTimesteps(xmlDoc) {
    const xmlLayers = xmlDoc.getElementsByTagName("Layer");

    // console.log("Extracting timesteps...");

    const rasterLayers = [];

    // console.log(`Num map layers : ${Object.keys(mapLayers).length}`)

    for (var key in mapLayers) {
        const currMapLayerGroup = mapLayers[key];
        for(let i = 0; i < currMapLayerGroup.length; i++) {
            const mapLayer = currMapLayerGroup[i];
            rasterLayers.push(mapLayer);
        } 
    }

    // Do the same for the extra layers
    for (var key in extraMapLayers) {
        const currExtraMapLayer = extraMapLayers[key];
        rasterLayers.push(currExtraMapLayer);
    }

    // Array containing the relevant layers we care about
    const relevantLayers = [];

    for(let i = 0; i < rasterLayers.length; i++) {
        const tgtLayerName = rasterLayers[i].geoserverId;
        
        for(let i = 0; i < xmlLayers.length; i++) {
            const xmlLayer = xmlLayers[i];
    
            const name = xmlLayer.getElementsByTagName('Name');

            if(name[0].innerHTML === tgtLayerName) {
                // ! This has been left to allow for the debugging of
                // ! the XML document if the format changes in the future
                // console.log(xmlLayer);
                relevantLayers.push(xmlLayer);
                break;
            }
        }
    }

    // Go through each of the relevant layers and extract the timestamps
    for(let i = 0; i < relevantLayers.length; i++) {
        const relevantLayer = relevantLayers[i];
        const timesteps = [];

        const dimensions = relevantLayer.getElementsByTagName('Dimension');
        for(let j = 0; j < dimensions.length; j++) {
            const dim = dimensions[j];
            if(dim.getAttribute('name') === 'time') {
                // ! This has been left to allow for the debugging of
                // ! the XML document if the format changes in the future
                // console.log(dim.innerHTML);
                const timestampStrings = dim.innerHTML.split(",");
                for(let k = 0; k < timestampStrings.length; k++) {
                    timesteps.push(new Date(timestampStrings[k]));
                }
                break;
            }
        }

        // Determine whether this is a daily or hourly layer
        const step1 = roundToNearestHour(new Date(timesteps[0]));
        const step2 = roundToNearestHour(new Date(timesteps[1]));

        const timeDelta = ((step2 - step1) / (1000 * 60 * 60));

        // Save this data
        let mapLayer = null;
        for(var key in mapLayers) {
            const currMapLayerGroup = mapLayers[key];
            mapLayer = currMapLayerGroup.find(e => e.geoserverId === relevantLayer.getElementsByTagName('Name')[0].innerHTML);
            if(mapLayer)
                break;
        }

        if(!mapLayer) {
            // Try the extra map layers
            for(var key in extraMapLayers) {
                const currExtraMapLayer = extraMapLayers[key];
                if(currExtraMapLayer.geoserverId === relevantLayer.getElementsByTagName('Name')[0].innerHTML) {
                    mapLayer = currExtraMapLayer
                }
                if(mapLayer)
                    break;
            }
        }
        
        if(!mapLayer) {
            console.error(`Unable to find ${relevantLayer.geoserverId}`);
            continue;
        }

        mapLayer.timeSteps = timesteps;

        switch(timeDelta) {
            case 1:
                if(mapLayer.timeStepInterval.toLowerCase() != "hourly") {
                    console.error(`${mapLayer.geoserverId} : ${mapLayer.timeStepInterval} != hourly`)
                };
                break;
            case 3:
                if(mapLayer.timeStepInterval.toLowerCase() != "3-hourly") {
                    console.error(`${mapLayer.geoserverId} : ${mapLayer.timeStepInterval} != 3-hourly`)
                };
                break;
            case 24:
                if(mapLayer.timeStepInterval.toLowerCase() != "daily") {
                    console.error(`${mapLayer.geoserverId} : ${mapLayer.timeStepInterval} != daily`)
                };
                break;
        }
    }
}

/**
 * Initialises the search-box in the search tab
 */
function initialiseSearch() {
    const searchWidget = new Search({
        view: esriMapView
    });

    const searchInput = $(`#search-input-id`);
    const searchBtn = $(`#search-btn-id`);

    searchBtn.on('click', function() {
        const searchText = searchInput.val();
        if (searchText) {
            searchWidget.search(searchText);
        }
    });

    searchInput.on('keypress', function(event) {
        if(event.key === 'Enter') {
            const searchText = searchInput.val();
            if (searchText) {
                searchWidget.search(searchText);
            }
        }
    })
}

/**
 * Initialises the timeslider, sets the `timeSlider` global variable
 */
function initialiseTimeslider(initialLayer) {
    
    const params = new URLSearchParams({
        request: 'GetCapabilities',
        service: 'WMS',
        version: '1.3.0', // or the version supported by your WMS service
        layers: `fireweather:${initialLayer.geoserverId}`,
        query_layers: `fireweather:${initialLayer.geoserverId}`,
    });

    $.ajax({
        url: GEOSERVER_URL,
        method: 'GET',
        data: params.toString(),
        success: function(response) {
            // ! This has been left to allow for the debugging of
            // ! the XML document if the format changes in the future
            // const xmlString = new XMLSerializer().serializeToString(response);
            // console.log(xmlString)
            
            extractTimesteps(response);

            // Get the earliest start
            let startDate = new Date(Math.min(...initialLayer.timeSteps));
            let endDate = new Date(Math.max(...initialLayer.timeSteps));
            let intervalValue = 1;

            if(initialLayer.timeStepInterval.toLocaleLowerCase() === 'daily') {
                startDate = roundToNearestDay(startDate);
                endDate = roundToNearestDay(endDate);
                intervalValue = 24;
            }

            timeSlider = new TimeSlider({
                container: "timeslider-id",
                fullTimeExtent: {
                  start: startDate,
                  end: endDate
                },
                stops: {
                    interval: {
                      value: intervalValue,
                      unit: 'hours'
                    }
                },
                mode: "cumulative-from-start",
                layout: "wide",
                playRate: computeSliderPlayRate(2)
            });
            
            let sliderDebouncer;

            // Watch the timeslider time extent
            reactiveUtils.watch(
                // `timeExtent` is the property that holds the current
                // positions of the 'thumbs' for the timeslider.
                // Since we're using a mode that has only one thumb, we
                // only need the `end` value.
                () => timeSlider.timeExtent,
                (value) => {
                  // update layer view filter to reflect current timeExtent
                  clearTimeout(sliderDebouncer);

                  // Timeout to prevent sending off hundreds of requests
                  // when moving the timeslider in hourly mode
                  sliderDebouncer = setTimeout(() => {
                    
                    // Apply this to all of the maps
                    setMapTimeStep(value.end);

                  }, 250);
                }
            );

            // Set the default header values
            setTimesliderHeaderValue(initialLayer, initialLayer.timeSteps[0]);
        },
        error: function(xhr, status, error) {
            console.error(xhr, status, error);
        }
    })
}

// ! EVENT LISTENERS

// ! MAIN
$(window).on("load", function() {

    // This is so the browser can actually execute the function
    window.handleMapLayerBtnClick = handleMapLayerBtnClick;

    // Load in the navbar dynamically (this is 
    // how we reuse components in ancient times)
    $("#fwv-navbar-id").load("navbar.html", function() {
        attachDropdownListeners();
    });

    // Add interceptor to handle the authentication 
    // It intercept the specific request and add authorization headers
    addInterceptors() 

    attachNavbarListeners();
    generateMapLayerBtns("fire-danger-max-fire-danger-rating-layer-btn");
    setupSettingsSliderListener();
    setupFooterButtonListeners();
    setupBasemapDropdownBtn();
    setupSettingsBtnListeners();
    initSettingsLayers();
    attachPbftModalBtnListeners();

    // This will also initialise the basemap
    currentLayerObj = mapLayers['Fire Danger'][2];
    initialiseEsriBasemap(currentLayerObj);
    initialiseTimeslider(currentLayerObj);
    initialiseSearch();

    // Incidents should be on by default (refreshes every 2 minutes)
    incidentsLayer = new GraphicsLayer();
    incidentsRefreshLoop(120 * 1000);
    toggleSettingsBtn('incidents', true);

    setTimeout(function() {
        // Set the 'layers' button to active
        $('#layers-tab-btn-id').trigger("click");
        // Set the default layer button to max fire danger rating
        $(`#fire-danger-max-fire-danger-rating-layer-btn`).trigger("click");
    }, 1000)
});